module.exports = __webpack_public_path__ + "assets/img/3.7cb52024.png";